<template>
<div>
    <div class="error_popup popup-desktop" v-if="isLoading" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Please wait...</div>
            <div class="text-block-1102">While we get current offer details!</div>
        </div>
    </div>
    <div class="error_popup popup-desktop" v-if="showMessage" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Currently we do not offer {{currentDose}}mg Dosages of Tirzepatide.</div>
            <div class="text-block-1102">Would you like to lock in our all industry low pricing for 10mg dosage of Tirzepatide?</div>
            <div class="button-model-yes-no">
                <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="selectedYes()">Yes</a>
                <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="moveToSorryPage()">No</a>
            </div>
        </div>
    </div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements reportform">
                <a href="#" class="link-block-42 form-rep w-inline-block">
                    <img sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-294 form-rep">
                </a>
            </div>
        </div>
    </section>
    <section class="afterreport_section form-rep">
        <div class="questions-div form-rep">
            <div class="question-container" v-if="active_el==1">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">Do you currently take weight loss medication?<br></div>
                    <div class="felix-form-block form-rep top w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3416fdec-b089-e392-c3b8-07826e71b460">
                            <div class="div-block-1487">
                                <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','Yes')">YES</a>
                                <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','No')">NO</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==2">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">What weight loss drugs are you currently prescribed?<br></div>
                    <div class="form-subs form-rep">Include drugs you have taken in the last 2 weeks only.</div>
                    <div class="felix-form-block form-rep w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3abb582e-8853-a9ef-0290-ed0a78b0ffde">
                            <div class="rx_option_div">
                                <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed','Semaglutide')">
                                    <div class="text-block-1137">Semaglutide</div>
                                    <div class="text-block-1138">(Compound, Ozempic, or Wegovy)</div>
                                </a>
                                <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed','Tirzepatide')">
                                    <div class="text-block-1137">Tirzepatide</div>
                                    <div class="text-block-1138">(Compound, Mounjaro, Zepbound)</div>
                                </a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==3">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">What {{planOptions.currentGLPMed}} dosage are you currently taking?</div>
                    <div class="form-subs form-rep">❗To be approved for higher dosages, you must upload a clear photo of your current medication or past prescription showing your name and dosage. Without this, our doctors cannot legally prescribe an increased dose, and you must begin at the initial starter dosage schedule❗</div>
                    <div class="felix-form-block form-rep w-form">
                        <form @submit.prevent="setPlan()">
                            <select required class="select-field-9 w-select" v-model="planOptions.currentDose">
                                <option value="">Select dose...</option>
                                <option v-for="d in doseOption" :key="d" :value="d">{{d}} mg</option>
                            </select>
                            <input type="submit" data-wait="Please wait..." class="form-button form-rep w-button" value="Next -&gt;">
                        </form>
                    </div>
                    <div class="div-block-1941">
                        <div class="text-block-1127"><span class="text-span-240">Same Price. All Dosage Levels.</span><br>No Hidden Fees. Everything Included.</div>
                        <div class="treatsum_deetsdiv form">
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Initial Telehealth Visit</div>
                                </div>
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_meds-copy.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Prescription + Medication</div>
                                </div>
                            </div>
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">24/7 Support</div>
                                </div>
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_appointment.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Monthly check-in</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==4">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">Choose your medication:<br></div>
                    <div class="felix-form-block form-rep w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16">
                            <div class="program-choice-div products">
                                <a href="#" class="link-block-48 sema w-inline-block" @click.prevent="setValue('selectedGLPMed','Semaglutide')">
                                    <div class="div-block-1643 sema" style="position: relative;">
                                        <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                        <div class="text-block-719"><span class="text-span-174 sema">Most Popular</span></div>
                                        <div class="form-product-2">Semaglutide</div>
                                        <div class="text-block-724">Compounded with B12 (Cyanocobalamin)</div>
                                        <p class="paragraph-126 report"></p>
                                        <div class="div-block-1949">
                                            <div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3" style="background-color: #c9e8ff;"><strong>Up to 16%</strong> Weight Loss</div>
                                                </div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3" style="background-color: #c9e8ff;">Works on <strong>1 </strong>GLP Receptor</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Prescribed GLP-1 </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                        <div class="text-block-1140">As low as $98.99 a month.</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" style="color:#fff" value="Get Started">
                                    </div>
                                </a>
                                <a href="#" class="link-block-48 tirz w-inline-block" @click.prevent="setValue('selectedGLPMed','Tirzepatide')">
                                    <div class="div-block-1643 tirz" style="position: relative;">
                                        <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                        <div class="text-block-719"><span class="text-span-174 tirz">Most Effective</span></div>
                                        <div class="form-product-2">Tirzepatide</div>
                                        <div class="text-block-724">Compounded with B6 <br class="hide-from-mobile">(Pyridoxine)</div>
                                        <p class="paragraph-126 report"></p>
                                        <div class="div-block-1949">
                                            <div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3 _2"><strong>Up to 22% </strong>Weight Loss*</div>
                                                </div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3 _2">Works on <strong>2</strong> GLP Receptors.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Effective GLP-1</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                        <div class="text-block-1140">As low as $170.99 a month.</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" style="color:#fff" value="Get Started">
                                    </div>
                                </a>

                            </div>
                            <div class="div-block-1503">
                                <!--<a href="#" class="link-40">Not sure which one?</a>-->
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </div>
    </section>
    <div style="height:280px"></div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex';
import {
    getProductsById
} from '@/utils/productData';

export default {
    components: {

    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            showMessage: false,
            active_el: 1,
            isLoading: false,
            planOptions: {
                currentlyTakingGLP: '',
                currentGLPMed: '',
                selectedGLPMed: '',
                selectedPlanTerms: '',
                currentDose: ''
            }
        }
    },
    computed: {
        ...mapGetters(['user']),
        doseOption() {
            if (this.planOptions.currentGLPMed === 'Semaglutide') {
                return [0.25, 0.5, 1, 2, 2.5];
            }
            return [2.5, 5, 7.5, 10, 12.5, 15];
        },
        bmi() {
            const heightInInches = parseFloat(this.user.height_inch);
            const weightInPounds = parseFloat(this.user.weight);
            return (weightInPounds / (heightInInches * heightInInches)) * 703;
        }
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0)
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility',
            'clearCart'
        ]),
        scrolltoTop() {
            setTimeout(function () {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);
        },
        selectedYes() {
            this.showMessage = false;
            this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
            this.moveToCheckout();
        },
        setPlan() {
            if (this.planOptions.currentDose == null) {
                return false;
            }
            //calculate BMI
            if (this.bmi < 20) {
                this.addTagForDisqualify();
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "We cannot proceed since your BMI is less than 20. "
                    }
                });
                return false;
            } else {
                this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                localStorage.setItem('currentMed', JSON.stringify({
                    med: this.planOptions.currentGLPMed,
                    dose: this.planOptions.currentDose
                }))
                this.moveToCheckout();
            }
        },
        async setValue(field, value) {
            this.planOptions[field] = value;
            if (field === 'currentlyTakingGLP' && value === 'No') {
                if (this.bmi < 20) {
                    this.addTagForDisqualify();
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your BMI is less than 20. "
                        }
                    });
                    return false;
                }
                localStorage.setItem('currentGlpMed', JSON.stringify(value));
                this.moveNext(3);
            } else if (field === 'selectedGLPMed') {
                this.moveToCheckout();
            } else {
                this.moveNext(1);
            }
        },
        addTagForDisqualify() {
            this.$axios.get(`${this.baseUrl}/forms/add-disqualify`);
        },
        moveToSorryPage() {
            this.$router.push("/sorry?message=We're truly sorry to see you go. We'll notify you as soon as the doses are available.")
        },
        async moveToCheckout() {
            await this.clearCart();
            let productId = this.planOptions.selectedGLPMed === 'Tirzepatide' ? '675ac4cb6bf102c19ec3afe9' : '675ac4cb6bf102c19ec3afec'
            let product = await getProductsById(productId);
            let plan = product[0]
            const cartItem = {
                id: plan.id,
                name: plan.name,
                category: plan.category.primary,
                price: plan.pricing.retail_price,
                retail_price: plan.pricing.retail_price,
                subheader: 'Compound Medication',
                sku: plan.sku,
                stripe_id: plan.stripe_id,
                quantity: 1, // Ensure it's a valid number
                image: `https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                is_addon: false,
            };
            
            this.saveCart(cartItem);
        },
        saveCart(cartItem) {
            this.isLoading = true;
            let postData = {
                ...cartItem,
                sema_offer: this.$store.getters.offerSema,
                tir_offer: this.$store.getters.offerTir,
                currentGLPMed: this.planOptions.currentGLPMed,
                currentDose: this.planOptions.currentDose,
            };

            this.$axios.post(`${this.baseUrl}/api/save-cart`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if (response.data.status === 'success') {
                        this.$store.dispatch('addToCart', cartItem);
                        this.setCartVisibility(false);
                        this.isLoading = false;
                        this.$router.push({
                            name: 'checkoutWeightLoss',
                            params: {
                                cart_id: response.data.id
                            }
                        });
                    } else {
                        alert("Unexpected response:", response.data);
                    }
                })
                .catch(error => {
                    console.log(error)
                });

        },
        moveNext(step) {
            console.log('offer from store ', this.$store.getters.weightLossOffer)
            this.active_el = this.active_el + step;
        },
    }
}
</script>

<style scoped>
.klarna-badge {
    position: absolute;
    top: 2px;
    right: -6px;
    width: 46px;
    height: auto;
    z-index: 2;
}

.link-block-48.tirz,
.link-block-48.sema {
    background-position: 90% 16% !important;
}

@media screen and (max-width: 479px) {
    .klarna-badge {
        width: 48px;
        top: 2px;
        right: -4px;
    }
    .link-block-48.tirz,
    .link-block-48.sema {
        background-position: 95% 26% !important;
    }
}

.button-model-yes-no {
    display: flex;
    justify-content: space-around;
    gap: 15%;
    width: 100%
}

.questions-div.form-rep {
    padding-top: 30px;
    padding-bottom: 50px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
}

.button-107 {
    width: 45%
}

.text-span-174.sema {
    background-color: #c9e8ff;
}

.CollectJSGooglePayIFrame {
    height: 50px !important;
}

.gpay-card-info-container.white.border-inset,
.gpay-card-info-animation-container.white.border-inset {
    height: 48px !important;
}

</style>
